@use "../../sass/variables/dimensions";

.ux-sidebar {
  &__inner {
    background-color: #fff;
    bottom: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    max-width: var(--ux-sidebar-max-width);
    position: fixed;
    right: -100%;
    top: 0;
    transition: right 0.3s ease-in-out;
    width: var(--ux-sidebar-width);
    z-index: 9999;

    &--align-header {
      top: var(--ux-sidebar-align-header);
    }

    &--align-footer {
      bottom: var(--ux-sidebar-align-footer);
    }

    &--align-left {
      left: -100%;
      transition: left 0.3s ease-in-out;
    }

    &--no-transition {
      transition: none;
    }
  }

  &__backdrop {
    background-color: rgba(0, 0, 0, 0.7);
    bottom: 0;
    display: block;
    height: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 0.2s ease-in-out;

    &--no-transition {
      transition: none;
    }
  }

  &__head {
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: flex-end;
    padding: dimensions.$dim-15 dimensions.$dim-15 0 0;
  }

  &__close {
    appearance: none;
    background: transparent;
    border: 0 none transparent;
    cursor: pointer;
    height: dimensions.$dim-40;
    margin: 0;
    outline: none;
    padding: 0;
    width: dimensions.$dim-40;
  }

  &__slot {
    align-items: stretch;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    max-height: calc(100% - 55px);
    width: 100%;
  }
}

.ux-sidebar--open {
  .ux-sidebar__inner {
    right: 0;
  }

  .ux-sidebar__inner--align-left {
    left: 0;
  }

  .ux-sidebar__backdrop {
    height: auto;
    opacity: 1;
  }

  .ux-date-range-picker .ux-date-picker {
    flex: 1 1 auto;
    width: 100%;
  }

  .ux-date-range-picker__container {
    align-items: stretch;
    flex-direction: column;
    justify-content: stretch;
  }

  .ux-date-picker .ux-date-picker__container {
    left: 0;
    right: 0;
    width: auto;
  }
}
